import { FC } from 'react';
import EditPermissionsNew from '@/components/permissions/edit-permissions-new';
import { Button, Flex } from '@mantine/core';

const EmployeePermissionsTab: FC<{ employee: any }> = ({ employee }: any) => {



    return (<>

   
        <EditPermissionsNew employee={employee} onUpdate={(selectedPermissionIDs: any) => { }} />

        <style jsx>{`
            
        `}</style>
    </>);
};

export default EmployeePermissionsTab;